export const version = 'kunde-v1.20.0-SNAPSHOT-3d39b12666e91a81849ad797b26051a4a3295b66';